import {
  INTEGRATION_URL_AUTH_USER_SEARCH_SUCCESS,
  INTEGRATION_GET_API_KEY_START,
  INTEGRATION_GET_API_KEY_SUCCESS,
  INTEGRATION_GET_API_KEY_FAIL,
  INTEGRATION_REGENERATE_SECRET_START,
  INTEGRATION_REGENERATE_SECRET_SUCCESS,
  INTEGRATION_REGENERATE_SECRET_FAIL,
} from '../../actions/flowBlockInput';

export const INITIAL_STATE = {
  personSearchResults: [],
  currentApiKeyUserName: null,
  apiKey: null,
  apiKeyError: null,
};

export default function authReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case INTEGRATION_URL_AUTH_USER_SEARCH_SUCCESS: {
      // Remove blanks, only keep up to 10 results:
      const personSearchResults = action.payload.filter(person => person);
      personSearchResults.length = Math.min(personSearchResults.length, 20);

      return {
        ...state,
        personSearchResults,
      };
    }
    case INTEGRATION_REGENERATE_SECRET_START:
    case INTEGRATION_GET_API_KEY_START: {
      return {
        ...state,
        apiKey: null,
        currentApiKeyUserName: null,
        hasApiKeyError: false,
      };
    }
    case INTEGRATION_REGENERATE_SECRET_SUCCESS:
    case INTEGRATION_GET_API_KEY_SUCCESS: {
      const { userName, apiKey } = action.payload;

      return {
        ...state,
        apiKey,
        currentApiKeyUserName: userName,
        hasApiKeyError: false,
      };
    }
    case INTEGRATION_REGENERATE_SECRET_FAIL:
    case INTEGRATION_GET_API_KEY_FAIL: {
      return {
        ...state,
        hasApiKeyError: true,
      };
    }
    default:
      return state;
  }
}
